import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const InfoRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  ${props =>
    props.cancelled &&
    css`
      text-decoration: line-through;
      opacity: 0.5;
    `}
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
